import { DEFAULT_LOCALE } from '../i18n/locale';
import {
  type Mugshot,
  Phase,
  type Player,
  PlayerStatus,
  Presence,
  type Room,
  type RoomOptions,
  UNDERCOVER_MODE_ID,
} from '../schemas';
import { ALL_CATEGORIES } from './categories';

export interface CreateRoomInput {
  id: string;
  code: string;
  hostId: string;
  hostName: string;
  hostMugshot?: Mugshot;
  options: RoomOptions;
  /** Wall-clock ms. */
  now: number;
  /** Set by online callers binding a room to e.g. a Discord Activity instance. */
  externalKey?: string;
}

export const DEFAULT_OPTIONS: RoomOptions = {
  includeClochard: true,
  locale: DEFAULT_LOCALE,
  categories: [...ALL_CATEGORIES],
  discussionSeconds: 90,
  randomizeSpeakingOrder: false,
  infiltreCount: 1,
  hideCode: false,
};

export const createRoom = (input: CreateRoomInput): Room => {
  const host: Player = {
    id: input.hostId,
    name: input.hostName,
    status: PlayerStatus.Alive,
    isHost: true,
    order: 0,
    presence: Presence.Online,
    lastSeenAt: input.now,
    ...(input.hostMugshot ? { mugshot: input.hostMugshot } : {}),
  };
  return {
    id: input.id,
    code: input.code,
    modeId: UNDERCOVER_MODE_ID,
    phase: Phase.Lobby,
    players: [host],
    options: input.options,
    speakingOrder: [],
    votes: [],
    nextRoundRequests: [],
    revealAcknowledgedBy: [],
    round: 0,
    createdAt: input.now,
    lastActivityAt: input.now,
    ...(input.externalKey ? { externalKey: input.externalKey } : {}),
  };
};
